export default __webpack_public_path__ + "static/media/nat-7.d123ec98.jpg";